import { ObservabilityMetricType } from '@inditex/core-o11y-js';
import { useObservabilityStore } from 'src/store/useObservability/useObservabilityStore';
import { sendMetric } from '../../../observabilityUtils';
import { ProductUploadTags, UploadCompletedTags, UploadMethodsSummaryTags, UploadMethodTags, UploadSignedUrlRetryTags } from '../productUploadTypes';
import { ProductUploadMetricName } from '../metricProductUploadNames';

const sendProductUploadCounter = (name: ProductUploadMetricName, tags: ProductUploadTags): void => {
  sendMetric({ name, type: ObservabilityMetricType.COUNTER, value: 1, tags });
};

export const generateUploadId = (): string => Date.now().toString(36) + Math.floor(Math.random()*1000);

export const trackUploadsStarted = (uploadId: string): void =>
  sendProductUploadCounter(ProductUploadMetricName.UPLOADS_STARTED, { upload_id: uploadId });

export const trackUploadMethodUsed = (tags: UploadMethodTags): void => {
  const uploadId = useObservabilityStore.getState().observabilityData?.uploadId;
  const SET_UPLOAD_ID = useObservabilityStore.getState().SET_UPLOAD_ID;
  let resolvedUploadId = uploadId;
  if(!uploadId) {
    resolvedUploadId = generateUploadId();
    SET_UPLOAD_ID(resolvedUploadId);
  }
  return sendProductUploadCounter(ProductUploadMetricName.UPLOAD_METHOD_USED, { ...tags, upload_id: resolvedUploadId });
};

export const trackUploadsCompleted = (tags: UploadCompletedTags): void => {
  const uploadId = useObservabilityStore.getState().observabilityData?.uploadId;
  return sendProductUploadCounter(ProductUploadMetricName.UPLOADS_COMPLETED, { ...tags, outcome: 'completed', upload_id: uploadId ?? '' });
};

export const trackUploadMethodsSummary = (tags: UploadMethodsSummaryTags): void => {
  const uploadId = useObservabilityStore.getState().observabilityData?.uploadId;
  return sendProductUploadCounter(ProductUploadMetricName.UPLOADS_METHODS_SUMMARY, { ...tags, upload_id: uploadId ?? '' });
};

export const trackUploadSignedUrlRetry = (tags: UploadSignedUrlRetryTags): void =>
  sendProductUploadCounter(ProductUploadMetricName.UPLOAD_SIGNED_URL_RETRY, tags);
